<script setup lang="ts">
import { Button } from '@toruslabs/vue-components/Button';
import MocaIDLogo from '../../assets/claim/moca-id-logo.svg';
import MocaExplore from '../../assets/claim/moca-explore.svg';
import { config } from "../../config";

const redirectToMocaverse = () => {
    window.open(config.mocaverseURL, '_blank');
}
</script>

<template>
    <div class="flex flex-col items-start justify-start">
        <img class="h-6 mb-7" :src="MocaIDLogo" />
        <div class="flex flex-col gap-2 items-start">
            <p class="text-moca-gray-1 text-sm font-normal">You are all set!</p>
            <p class="text-2xl text-white font-bold">Let's explore<br /><span class="text-moca-yellow">Mocaverse</span></p>
            <p class="text-moca-gray-1 text-sm font-normal">
                Mocaverse offers fun and exciting rewards for Moca ID holders.
                <br /><br />
                We also provide bonus rewards for those of you that share it with your friends, so be sure to let them know!
                <br /><br />
                Click the link below to learn more about all we have to offer.
            </p>
        </div>
        <img :src="MocaExplore" class="my-5 mx-auto" />
        <Button
            class="!bg-moca-transparent !text-moca-gray-3 !text-lg !font-bold !border-2 !border-moca-gray-3 !h-11 !rounded-full mx-auto"
            @on-click="redirectToMocaverse">
            Learn More
        </Button>
    </div>
</template>
